import { ReactElement } from 'react';

import { GynecologicalInterview } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { GynecologicalInterviewModal } from './gynecologicalInterviewModal/GynecologicalInterviewModal';

type GynecologicalInterviewModalOpenerRenderer = (renderProps: { openModal: VoidFunction }) => ReactElement;

type GynecologicalInterviewModalOpenerProps = {
   readonly gynecologicalInterview: GynecologicalInterview;
   readonly children: GynecologicalInterviewModalOpenerRenderer;
   readonly onMedicalDataAccessAuthorizationUpdate: VoidFunction;
};

export const GynecologicalInterviewModalOpener = (props: GynecologicalInterviewModalOpenerProps): JSX.Element => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <GynecologicalInterviewModal
               gynecologicalInterview={props.gynecologicalInterview}
               onClose={closeModal}
               onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
            />
         ) : null}
      </>
   );
};
